export enum LoginScreen {
  LOGIN_FORM = "loginForm",
  CHANGE_PASSWORD_FORM = "changePasswordForm",
}
